<template>
  <div>
    <Header />
    <div class="title">
      <span class="navTitle"><span>Expositions</span> > Ajouter une exposition</span>

      <div class="info-icon">
        <q-btn flat round dense icon="info">
          <q-popup-proxy ref="popup">
            <q-card>
              <q-card-section>
                Valider le nom de votre exposition pour créer votre exposition
              </q-card-section>
            </q-card>
          </q-popup-proxy>
        </q-btn>
      </div>
    </div>
    <br>
    <q-btn color="pink-10" style="margin-left: 7%" @click="navigate">Retour</q-btn>

    <hr style="margin-bottom: 15px;">

    <q-form class="form" style="margin: auto; width: 50%;">
      <q-input outlined v-for="(field, index) in formFields" :key="index" :label="field"
        v-model="newForm[formFieldsDb[index]]" style='margin-bottom: 2%'>
      </q-input>
      <q-btn color="secondary" @click="send"> Ajouter </q-btn>
    </q-form>
    <br>
    <q-banner v-if="apiResponse" class="app-banner app-banner--success" dense rounded>
      Exposition créée
    </q-banner>
  </div>
</template>

<script>
import { ref } from "vue";
import axios from "axios";
import { useStore } from "vuex";
import Header from "../components/Header.vue";
import { useRouter } from "vue-router";

export default {
  components: {
    Header,
  },
  setup() {
    const store = useStore();
    const formFields = ["Nom de l'exposition"];
    const formFieldsDb = ["name"];
    const router = useRouter();
    const id = ref(store.state.userId);
    let showInfo = ref(false);
    const newForm = {
      name: "",
    };
    const apiResponse = ref(false);

    const navigate = () => {
      router.push({ path: "/admin/" });
    };

    const send = async () => {
      const url = `${process.env.VUE_APP_BASEURL}/exhibit`;
      const body = {
        userId: id.value,
        name: newForm.name,
      };
      const response = await axios.post(url, body);
      if (response.status == 200) {
        apiResponse.value = true;
        setTimeout(() => {
          apiResponse.value = false;
          router.push({ name: 'Admin' });
        }, 4000);
      }
    };

    return {
      formFields,
      formFieldsDb,
      newForm,
      apiResponse,
      showInfo,
      navigate,
      send,
    };
  },
};
</script>

<style scoped>
.banner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999;

  /* Design */
  padding: 15px 30px;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  /* Typographie */
  font-size: 16px;
  font-family: 'Helvetica', sans-serif;  /* Remplacez par la police de votre choix */
  
  /* Transition */
  transition: all 0.3s ease-in-out;
}

.title {
  display: flex;
  align-items: center;
  font-size: 1.2 rem;
  margin-left: 1%;
}
</style>
